// build: 2026-06-26
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import './i18n';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import {icons} from './assets/icons';
import {Provider} from 'react-redux';
import store from './store';
import I18nSubscriber from './i18n/I18nSubscriber';
import axios from 'axios';
import {setupAxios} from './helpers/apiHelper';

import $ from 'jquery';
import moment from 'moment';

window.jQuery = $;
window.$ = $;
window.moment = moment;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

setupAxios(axios, store);

React.icons = icons;

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Provider store={store}>
      <I18nSubscriber>
        <App />
      </I18nSubscriber>
    </Provider>
  </BrowserRouter>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
